import {gql} from "@apollo/client";

export const ALL_CONTENT_INFOS = gql`
    query GetContentInfos {
        contentInfos {
            id
            name
            nameExternal
            code
            description
            level
            contentType
            isAssessed
            externalUrl
            externalUrlName
            serviceType {
                id
                keycode
                description
                isDefault
            }
            created
            updated
        }
    }
`;

export const ALL_PUBLISHING_PLANS = gql`
    query GetPublishingPlans {
        contentPublishingPlans {
            id
            from
            to
            perpetual
            content {
                id
                name
                level
            }
        } 
    }
`;

export const DELETE_PUBLISHING_PLAN = gql`
    mutation DeletePublishingPlans($planId: Int!) {
        deleteContentPublishingPlan(input: { planId: $planId})
    }
`;

export const ALL_USERS = gql`
    query GetUsers {
        users {
            id
            givenName
            familyName
            displayName
            email
            canTeach
            canContentManage
            canTrafficManage
            canCustomerSupport
            canLiveOps
            canQA
            canAdmin
        }
    }
`;

export const UPDATE_USER = gql`
    mutation UpdateUser($id: Int!, $givenName: String!, $familyName: String!, $displayName: String!, $canTeach: Boolean!, $canContentManage: Boolean!, 
        $canTrafficManage: Boolean!, $canCustomerSupport: Boolean!, $canLiveOps: Boolean!, 
        $canQA: Boolean!, $canAdmin: Boolean!) {
        updateUser(input: {
            id: $id
            givenName: $givenName
            familyName: $familyName
            displayName: $displayName
            canTeach: $canTeach
            canContentManage: $canContentManage
            canTrafficManage: $canTrafficManage
            canCustomerSupport: $canCustomerSupport
            canLiveOps: $canLiveOps
            canQA: $canQA
            canAdmin: $canAdmin
        }) {
            id
            givenName
            familyName
            displayName
            email
            canTeach
            canContentManage
            canTrafficManage
            canCustomerSupport
            canLiveOps
            canQA
            canAdmin
        }
    }
`;

export const DELETE_USER = gql`
    mutation DeleteUser($id: Int!) {
        deleteUser(input: {
            id: $id
        }) {
            id
        }
    }
`;

export const THIS_USER = gql`
    query ThisUser {
        me {
            id
            givenName
            familyName
            email
            canTeach
            canQA
            canContentManage
            canTrafficManage
            canCustomerSupport
            canLiveOps
            canAdmin
            assignedRoles @client
        }
    }`
    ;

export const QUERY_ALL_PERFORMERS = gql`
    query GetTeachingUsers {
        users_filtered(filter: {
            anyPermissions: [TEACH]
        }) {
            id
            displayName
            familyName
            email
            canTeach
        }
    }
`;


export const QUERY_CAN_TEACH_DOMAIN_USERS_AND_THEIR_AVAILABILITY_FILTERED_BY_TIME = gql`
    query GetTeachingUsersAndTheirAvailability($fromTime: DateTime, $toTime: DateTime, $includeOnlyAccreditedServiceTypes: Boolean, $serviceTypeKeyCodes: [String!]) {
        serviceTypes {
            keycode
            primaryColor
            description
        }
        users_filtered(filter: {
            anyPermissions: [TEACH]
        }) {
            id
            displayName
            familyName
            email
            canTeach
            availability(filter: {from: $fromTime, to: $toTime, includeOnlyAccreditedServiceTypes: $includeOnlyAccreditedServiceTypes, serviceTypeKeyCodes: $serviceTypeKeyCodes}) {
                id
                from
                performingFrom
                to
                bookableServiceTypes {
                    id
                    startTime
                    endTime
                    isBookable
                    serviceType {
                        keycode
                    }
                }
                sessions {
                    id
                    from
                    to
                    sessionType
                    seatsCount
                    isTeachingSession
                    isLocked
                    serviceType {
                        keycode
                        primaryColor
                        description
                    }
                    bookingsCount
                    contents {
                        id
                        name
                        level
                    }
                }
            }
        }
    }
`;

export const QUERY_CAN_TEACH_DOMAIN_USERS_AND_THEIR_TIMESLOT_FILTERED_BY_TIME = gql`
    query GetTeachingUsersAndTheirTimeslot($fromTime: DateTime, $toTime: DateTime, $includeOnlyAccreditedServiceTypes: Boolean, $serviceTypeKeyCodes: [String!]) {
        serviceTypes {
            keycode
            primaryColor
            timeslotLengthInSeconds
          }
        users_filtered(filter: {
            anyPermissions: [TEACH]
        }) {
            id
            displayName
            familyName
            email
            canTeach
            availability(filter: {from: $fromTime, to: $toTime, includeOnlyAccreditedServiceTypes: $includeOnlyAccreditedServiceTypes, serviceTypeKeyCodes: $serviceTypeKeyCodes}) {
                id
                from
                performingFrom
                to
                bookableServiceTypes {
                    id
                    startTime
                    endTime
                    isBookable
                    serviceType {
                        keycode
                    }
                }
                sessions {
                    serviceType {
                        keycode
                        primaryColor
                    }
                    from
                    to
                    sessionType
                    isLocked
                }
            }
        }
    }
`;

export const QUERY_CAN_TEACH_DOMAIN_USERS_AND_THEIR_SHIFT_DATA_FILTERED_BY_TIME = gql`
    query GetTeachingUsersAndTheirShiftData($fromTime: DateTime, $toTime: DateTime, $includeOnlyAccreditedServiceTypes: Boolean, $serviceTypeKeyCodes: [String!]) {
        serviceTypes {
            keycode
            primaryColor
          }
        users_filtered(filter: {
            anyPermissions: [TEACH]
        }) {
            id
            displayName
            familyName
            email
            canTeach
            availability(filter: {from: $fromTime, to: $toTime, includeOnlyAccreditedServiceTypes: $includeOnlyAccreditedServiceTypes, serviceTypeKeyCodes: $serviceTypeKeyCodes}) {
                id
                performingFrom
                from
                to
                bookableServiceTypes {
                    id
                    startTime
                    endTime
                    isBookable
                    serviceType {
                        keycode
                    }
                }
            }
        }
    }
`;

export const LOOKUP_SHIFT_CHECK_IN_STATUS = gql`
    query GetShiftCheckInStatus($shiftIds: [Int]!) {
        shifts(filter: {shiftIds: $shiftIds}) {
            id
            performerCheckInTime
            checkInStatus
        }
    }
`;

export const LOOKUP_SESSION_WITH_CHILDREN = gql`
    query GetSessionWithChildren($sessionId: Int!) {
        sessionInfo(filter: {sessionId: $sessionId}) {
                id
                seats {
                    id
                    booking {
                        id
                        attendedSessionReport {
                            serviceTypeKeycode
                            countOfAttendedSessions
                            countOfAttendedSessionsWithPerformer
                        }
                        child {
                            id
                            displayName
                            displayNameRomanized
                            gender
                            dateOfBirth
                            parent {
                                region
                                externalId
                            }
                        }
                    }
                }
        }
    }
`;

export const SESSION_HEALTH_STATUS = gql`
    query GetSessionHealth($sessionId: Int!) {
        sessionHealth(filter: {sessionId: $sessionId}) {
            key
            state
        }
    }
`;

export const LOOKUP_SESSION_WITH_RECORDING_AND_HEALTH_DATA = gql`
    query GetSessionInfoWithRecordingAndHealthData($sessionId: Int!) {
        sessionInfo(filter: {sessionId: $sessionId}) {
            id
            isHealthy
            currentHealthEventType
            actualSessionStartTime
            zoomMeetingUrl
            lessonRecordingStatus
            zoomMeetingRecordingUrls {
                recordingType
                recordingUrl
            }
            shift {
                performerCheckInTime
            }
        }
    }
`;

export const LOOKUP_SESSION_WITH_CHILDREN_DETAILS = gql`
    query GetSessionInfoWithChildrenData($sessionId: Int!) {
        sessionInfo(filter: {sessionId: $sessionId}) {
            id
            seats {
                booking {
                    child {
                        id
                        displayName
                        displayNameRomanized
                        gender
                        dateOfBirth
                        parent {
                            externalId
                            region
                        }
                    }
                }
            }
        }
    }
`;

export const LOOKUP_SESSION_WITH_SESSION_RECORDING = gql`
    query GetSessionInfo($sessionId: Int!) {
        sessionInfo(filter: {sessionId: $sessionId}) {
            zoomMeetingUrl
            lessonRecordingStatus
            zoomMeetingRecordingUrls {
                recordingType
                recordingUrl
            }
        }
    }
`;


export const LOOKUP_FILTERED_BOOKINGS = gql`
    query GetFilteredBookings($pageNumber: Int!, $pageSize: Int!, $externalId: String!, $filterCriterion: [FilterCriterion!]!, $logicOperator: LogicOperator!, $sortBy: String, $sortOrder: SortOrder) {
        filteredBookings(filter: {pageNumber: $pageNumber, pageSize: $pageSize, externalId: $externalId, filterCriteria: {filterCriterion: $filterCriterion, logicOperator: $logicOperator}, sortBy: $sortBy, sortOrder: $sortOrder}) {
            bookings {
                id
                lessonStartTime
                isForceCancellable
                child {
                    externalId
                    displayName
                    displayNameRomanized
                }
                assessment {
                    id
                    pass
                    tags{
                        id
                        name
                        description
                    }
                }                   
                status
                reasonCode
                eligibleForRefund
                refunded
                refundedBy

                serviceType {
                    keycode
                    description
                }
            
                contents {
                    id
                    name
                    level
                    contentType
                    isAssessed
                }
                seat {
                    id
                    lesson {
                        id
                        performer {
                            givenName
                        }
                    }
                }
                created
                updated
            }
            totalBookingsCount
        }
    }
`;

export const LOOKUP_SESSION_WITH_REGION_COUNT = gql`
    query GetSessionInfoWithRegionAndSeatCount($sessionId: Int!) {
        sessionInfo(filter: {sessionId: $sessionId}) {
                id
                regionalSeatInfo {
                      region
                      count
            }
        }
    }
`;

export const UPDATE_CONTENT_INFO = gql`
    mutation UpdateContent($id: Int!, $name: String!, $nameExternal: String, $code: String, $contentType: ContentType!, $description: String, $externalUrl: String!, $externalUrlName: String!, $capLevel: CapLevel!, $isAssessed: Boolean) {
        updateContentInfo(input: {
            id: $id
            name: $name
            nameExternal: $nameExternal
            code: $code
            contentType: $contentType
            description: $description
            externalUrl: $externalUrl
            externalUrlName: $externalUrlName
            level: $capLevel
            isAssessed: $isAssessed
        }) {
            id
            name
            nameExternal
            code
            level
            isAssessed
            contentType
            description
            externalUrl
            externalUrlName
            created
            updated
        }
    }
`;

export const CREATE_CONTENT_INFO = gql`
    mutation CreateContent($name: String!, $nameExternal: String, $code: String, $description: String, $serviceTypeKeycode: String, $theCapLevel: CapLevel!, $contentType: ContentType!, $externalUrl: String!, $externalUrlName: String!, $contentFolderId: Int, $isAssessed: Boolean) {
        createContentInfo(input: {
            name: $name
            nameExternal: $nameExternal
            code: $code
            description: $description
            serviceTypeKeycode: $serviceTypeKeycode
            level: $theCapLevel
            isAssessed: $isAssessed
            contentType: $contentType
            externalUrl: $externalUrl
            externalUrlName: $externalUrlName
            contentFolderId: $contentFolderId
        }) {
            id
            name
            nameExternal
            code
            level
            isAssessed
            description
            externalUrl
            externalUrlName
            created
            updated
        }
    }
`;

export const DELETE_CONTENT_INFO = gql`
    mutation DeleteContent($id: Int!) {
        deleteContentInfo(input: {
            id: $id
        }) {
            id
        }
    }
`;

export const SWAP_SESSION = gql`
    mutation SwapSession($sessionId: Int!, $targetShiftId: Int!) {
        swapSessionAndMeeting(input: {
            sessionId: $sessionId
            targetShiftId: $targetShiftId
        }) {
            zoomMeetingSwapStatus
        }
    }
`;

export const FETCH_SWAPABILITY = gql`
    query SwapingOptions($sessionId: Int!) {
        swapability(filter: {sessionId: $sessionId}) {
            targetShift {
                id
                owner {
                    id
                    displayName
                }
            }
            ruleReport {
                ruleName
                isRuleSkipped
                swapRating
            }
            swapRating
            targetSessions {
                serviceType {
                    keycode
                }
                sessionType
            }
        }
    }
`;

export const GET_FILTERED_SHIFT_PLANS = gql`
    query GetShiftPlansFilteredByPerformer($startTime: DateTime!, $endTime: DateTime!, $performerId: Int!) {
        shiftPlans(filter: {
            startTime: $startTime
            endTime: $endTime
            performerId: $performerId
        }) {
            id
            startTime
            endTime
            updated
            bookableServiceTypePlans {
                serviceType {
                    keycode
                    description
                }
                startTime
                endTime
            }
            enrollments {
                fromTime
                toTime
                user {
                    id
                    displayName
                }
                availability {
                    id
                    performingFrom
                    to
                }
            }
        }
    }
`;

export const GET_SHIFT_PLANS = gql`
    query GetShiftPlansForTimeRange($startTime: DateTime!, $endTime: DateTime!) {
        shiftPlans(filter: {startTime: $startTime, endTime: $endTime}) {
            id
            startTime
            endTime
            enrollments {
                availability {
                    id
                    hasAnyTeachingSessions
                }
                user {
                    id
                }
            }
            bookableServiceTypePlans {
                serviceType {
                    keycode
                    description
                    primaryColor
                }
            }
        }
    }
`;

export const GET_BOOKING_STATS = gql`
    query GetBookingStats($serviceTypeKeycode: String!$from: DateTime!, $to: DateTime!, $grouping: TimeGroupingInterval!, $timezone: TimeZone!) {
        bookingStats(filter: {
            serviceTypeKeycode: $serviceTypeKeycode
            from: $from
            to: $to
            grouping: $grouping
            timezone: $timezone
        }) {
            statDate
            bookedSeats
            availableSeats
        }
    }
`;

export const GET_DETAILED_SHIFT_PLANS = gql`
    query GetDetailedShiftPlansForTimeRange($startTime: DateTime!, $endTime: DateTime!) {
        shiftPlans(filter: {startTime: $startTime, endTime: $endTime}) {
            id
            startTime
            endTime
            enrollments {
                user {
                    id
                    displayName
                }
                availability {
                    id
                    hasAnyTeachingSessions
                    from
                    performingFrom
                    to
                }
                fromTime
                toTime
                approvedFromTime
                approvedToTime
                conflictingRanges {
                    fromTime
                    toTime
                } 
                shiftSelectionStatus
            }
            bookableServiceTypePlans {
                id
                serviceType {
                    keycode
                    description
                    primaryColor
                }
                startTime
                endTime
            }
        }
    }
`;

export const SUBMIT_ASSESSMENT = gql`
    mutation SubmitAssessment($bookingId: Int!, $pass: Boolean!, $tags: [Int]) {
        submitAssessment(input: {
            bookingId: $bookingId,
            pass: $pass
            tags: $tags
        }) {
            id
            booking {
                id
            }
            pass
            tags {
                id
                name
            }
        }
    }
`;

export const ASSESSMENT_TAGS = gql`
  query GetAssessmentTags {
    tags(filter: { type: ASSESSMENT }) {
      id
      name
      description
      type
    }
  }
`;

export const GET_ASSESSMENTS = gql`
    query GetAssessments($bookingIds: [Int]!) {
        assessments(filter: {
            bookingIds: $bookingIds
        }) {
            id
            booking {
                id
            }
            pass
            tags {
                id
                description
            }
        }
    }
`;

export const MY_SHIFT_AND_BOOKINGS = gql`
    query GetMyShiftAndBookings($startTime: DateTime, $endTime: DateTime) {
        serviceTypes {
            keycode
            description
            primaryColor
            enableLaunchSessionBeforeMinutes
            disableLaunchSessionAfterMinutes
        }
        me {
            id
            availability(filter: {from: $startTime, to: $endTime}) {
                id
                from
                to
                performerCheckInTime
                checkInStatus
                hasCheckInTimeslot
                performingFrom
                bookableServiceTypes {
                    serviceType {
                        keycode
                        description
                        primaryColor
                        enableLaunchSessionBeforeMinutes
                        disableLaunchSessionAfterMinutes
                    }
                }
                sessions {
                    id
                    from
                    to
                    sessionType
                    isTeachingSession
                    serviceType {
                        keycode
                    }
                    seats {
                        booking {
                            id
                            status
                        }
                    }
                    zoomMeetingUrl
                    bookingsCount
                    contents {
                        id
                        name
                        level
                        isAssessed
                        externalUrl
                        externalUrlName
                        contentType
                    }
                }
            }
        }    
    }
`;

export const PERFORMER_SELF_CHECKIN = gql`
    mutation performerSelfCheckIn($shiftId: Int!) {
        checkInForShift(input: {
            shiftId: $shiftId
        }) {
            id
        }
    }
`;

export const FILTERED_SESSION_HISTORY = gql`
    query GetFilteredSessionHistory($performerId: Int!, $sessionType: SessionType!, $sessionScope: SessionScope!, $pageNumber: Int!, $pageSize: Int!, $filterCriterion: [FilterCriterion!]!, $logicOperator: LogicOperator!, $sortBy: String, $sortOrder: SortOrder) {
        serviceTypes {
            keycode
            description
            primaryColor
        }
        filteredSessions(filter: {performerId: $performerId, sessionType: $sessionType, sessionScope: $sessionScope, pageNumber: $pageNumber, pageSize: $pageSize, filterCriteria: {filterCriterion: $filterCriterion, logicOperator: $logicOperator}, sortBy: $sortBy, sortOrder: $sortOrder}) {
            sessions {
                id
                from
                to
                sessionType
                isTeachingSession
                performer {
                    id
                    displayName
                }
                serviceType {
                    keycode
                }
                firstChildJoinTime
                seats {
                    booking {
                        id
                        attendedSessionReport {
                            serviceTypeKeycode
                            countOfAttendedSessions
                            countOfAttendedSessionsWithPerformer
                        }
                        status
                        child {
                            id
                            displayName
                            displayNameRomanized
                            gender
                            dateOfBirth
                            parent {
                                externalId
                                region
                            }
                        }
                    }
                }
                contents {
                    id
                    name
                    level
                    isAssessed
                    contentType
                }
            }
            totalSessionsCount
        }
    }
`;

export const DELETE_SHIFT = gql`
    mutation DeleteShift($shiftId: Int!) {
        deleteShift(input: {
            id: $shiftId
        })
    }
`;

export const ALL_PERFORMERS_CONTENT_AND_ACCREDITATION = gql`
    query GetAllPerformersContentAndAccreditation {
        users_filtered(filter: {
            anyPermissions: [TEACH]
        }) {
            id
            displayName
        }

        contentInfos {
            id
            name
            level
        }

        contentPerformingAccreditations {
            id
            domainUser {
                id
            }
            contentInfo {
                id
            }
        }
    }
`;

export const LOOKUP_PARENT_WITH_CHILDREN = gql`
    query GetParentAndChildrenInfo($externalId: String!) {
        parentInfo(filter: {
            externalId: $externalId
        }) {
            id
            externalId
            displayName
            region
            bookingsCount
            
            children {
                id
                externalId
                displayName
                displayNameRomanized
                capLevel
                gender
                dateOfBirth
                tokenBalance
            }
        }    
    }
`;

export const CREATE_SHIFT_PLANS = gql`
    mutation CreateShiftPlans($createBookableServiceTypePlansInput: [CreateBookableServiceTypePlanInput], $startTime: DateTime!, $endTime: DateTime!, $includeCheckInTimeslot: Boolean!, $repeatFrequency: RepeatFrequency, $repeatFrom: DateTime, $repeatUntil: DateTime) {
        createShiftPlansWithReport(input: {
            createBookableServiceTypePlansInput: $createBookableServiceTypePlansInput
            startTime: $startTime
            endTime: $endTime
            includeCheckInTimeslot: $includeCheckInTimeslot
            repeatFrequency: $repeatFrequency
            repeatFrom: $repeatFrom
            repeatUntil: $repeatUntil
        }) {
            shiftPlans {
                id
            }
        }
    }
`;

export const DELETE_SHIFT_PLANS = gql`
    mutation DeleteShiftPlans($shiftPlanIds: [Int]!) {
        deleteShiftPlans(input: {
            shiftPlanIds: $shiftPlanIds
        })
    }
`;

export const GENERATE_SHIFTS = gql`
    mutation GenerateShifts($shiftPlans: [ShiftPlanServiceTypesInput]!) {
        generateShiftsFromShiftPlans(input: {
            shiftPlans: $shiftPlans
        }) {
            shiftPlans {
                id
                enrollments {
                    id
                    shiftSelectionStatus
                    availability {
                        id
                    }
                }
            }
        }
    }
`;

export const UPDATE_SHIFTS = gql`
    mutation UpdateShifts($shiftPlans: [ShiftPlanServiceTypesInput]!) {
        updateShiftsFromShiftPlans(input: {
            shiftPlans: $shiftPlans
        }) {
            shiftPlans {
                id
                enrollments {
                    id
                    shiftSelectionStatus
                    availability {
                        id
                    }
                }
            }
        }
    }
`;

export const ENROLL_PERFORMER_FROM_SHIFT_PLANS = gql`
    mutation EnrollPerformer($shiftPlanIds: [Int], $performerId: Int!, $shiftPlanSelections: [ShiftPlanSelectionRangeInput]) {
        enrollPerformer(input: {
            shiftPlanIds: $shiftPlanIds
            performerId: $performerId
            shiftPlanSelections: $shiftPlanSelections
        }) {
            id 
        }
    }
`;

export const UNENROLL_PERFORMER_FROM_SHIFT_PLANS = gql`
    mutation UnenrollPerformer($shiftPlanIds: [Int], $performerId: Int!, $shiftPlanSelections: [ShiftPlanSelectionRangeInput]) {
        unenrollPerformer(input: {
            shiftPlanIds: $shiftPlanIds
            performerId: $performerId
            shiftPlanSelections: $shiftPlanSelections
        }) {
            id    
        }
    }
`;

export const UPDATE_PERFORMER_SHIFT_SELECTION = gql`
    mutation UpdateShiftSelection($shiftPlanIds: [Int],$shiftPlanApprovals: [ShiftPlanSelectionRangeInput], $performerId: Int!, $isPerformerSelected: Boolean!) {
        updatePerformerShiftSelection(input: {
            shiftPlanIds: $shiftPlanIds
            shiftPlanApprovals: $shiftPlanApprovals
            performerId: $performerId
            isPerformerSelected: $isPerformerSelected
        }) {
            id
        }
    }
`;

export const MUTATION_CREATE_SHIFT = gql`
    mutation CreateShift($ownerId: Int!, $createBookableServiceTypesInput: [CreateBookableServiceTypeInput]!, $from: DateTime!, $to: DateTime!, $includeCheckInTimeslot: Boolean!) {
        createAvailability(input: {
            ownerId: $ownerId
            createBookableServiceTypesInput: $createBookableServiceTypesInput
            from: $from
            to: $to
            includeCheckInTimeslot: $includeCheckInTimeslot
        }) {
            id
            from
            to
        }
    }    
`;

export const MUTATION_UPDATE_SHIFT = gql`
    mutation UpdateShift($shiftId: Int!, $updateBookableServiceTypesInput: [UpdateBookableServiceTypeInput]!, $from: DateTime!, $to: DateTime!, $includeCheckInTimeslot: Boolean!) {
        updateShift(input: {
            shiftId: $shiftId
            updateBookableServiceTypesInput: $updateBookableServiceTypesInput
            from: $from
            to: $to
            includeCheckInTimeslot: $includeCheckInTimeslot
        }) {
            id
            from
            to
        }
    }    
`;

export const UPDATE_SHIFT_BLOCK_STATUS = gql`
    mutation UpdateShiftBlockStatus($shiftId: Int!, $isBlocked: Boolean!) {
        updateShiftBlock(input: {
            id: $shiftId
            isBlocked: $isBlocked
        })
    }
`;

export const CLEAR_SESSIONS = gql`
    mutation ClearSessions($shiftId: Int!) {
        clearSessions(input: {
            shiftId: $shiftId
        }) { 
            successfullyClearedSessionsCount  
            totalSessionsCount
        } 
    }
`;

export const PUBLISHED_ACCREDITED_CONTENT_FOR_SHIFT = gql`
    query GetAvailableContent($shiftId: Int!, $serviceTypeKeycode: String!) {
        availableContent(input: {
            shiftId: $shiftId,
            serviceTypeKeycode: $serviceTypeKeycode
        }) {
            id
            name
            contentType
        }
    }
`;

export const CREATE_SESSION = gql`
    mutation CreateSession($shiftId: Int!, $startTime: DateTime!, $endTime: DateTime, $contentIds: [Int], $sessionType: SessionType!) {
        createSession(input: {
            shiftId: $shiftId,
            startTime: $startTime,
            endTime: $endTime
            contentIds: $contentIds,
            sessionType: $sessionType
        }) {
            id
        }
    }
`;

export const UPDATE_SESSION_LOCK_STATUS = gql`
    mutation UpdateSessionLock($sessionId: Int!, $isLocked: Boolean!) {
        updateSessionLock(input: {
            sessionId: $sessionId,
            isLocked: $isLocked
        }) {
            id
        }
    }
`;

export const FORCE_CANCEL_BOOKING = gql`
    mutation ForceCancelBooking($bookingId: Int!) {
        forceCancelBooking(input: {
            bookingId: $bookingId
        }) {
            id
        }
    }
`;

export const DELETE_SESSION = gql`
    mutation DeleteSession($lessonId: Int!) {
        deleteLesson(input: {
            lessonId: $lessonId
        })
    }
`;

export const ALL_SERVICE_TYPES = gql`
    query serviceTypes {
        serviceTypes {
            keycode
            description
            isExternal
            isDefault
            isCapSegmented
            timeslotLengthInSeconds
            minPeriodsInShift
            maxPeriodsInShift
            primaryColor
        }
    }
`;

export const GET_CONTENT_DEFINITIONS = gql`
    query GetContentDefinitions { 
        contentInfos {
            id
            name
            description
            serviceType {
                keycode
            }
            level
        }
    }
`;


export const CREATE_CONTENT_PUBLISHING_PLAN = gql`
    mutation CreateContentPublishingPlan($contentId: Int!, $from: DateTime, $to: DateTime, $perpetual: Boolean!) {
        createContentPublishingPlan(input: {
            contentId: $contentId
            from: $from
            to: $to
            perpetual: $perpetual
        }) {
            id
        }
    }
`;

export const UPDATE_CONTENT_PUBLISHING_PLAN = gql`
    mutation UpdateContentPublishingPlan($planId: Int!, $from: DateTime, $to: DateTime, $perpetual: Boolean!) {
        updateContentPublishingPlan(input: {
            planId: $planId
            from: $from
            to: $to
            perpetual: $perpetual
        }) {
            id
        }
    }
`;

export const ALL_CONTENT_TYPES = gql`
    query ContentTypes { 
        contentTypes 
    }
`;

export const REFUND_BOOKING = gql`
    mutation RefundBooking($bookingId: Int!) {
        refundBooking(input: {
            bookingId: $bookingId
        }) {
            id
        }
    }
`;

export const GET_ALL_CONTENT_DATA = gql`
    query GetAllContentData {
        serviceTypes {
            id
            keycode
            description
            primaryColor
        }
        
        contentFolders {
            id
            name
            parentFolderId
            serviceType {
                id
                keycode
            }
        }
        
        contentInfos {
            id
            name
            description
            contentFolderId
            serviceType {
                id
                keycode
                description
            }
            nameExternal
            code
            created
            contentType
            level
            isAssessed
            externalUrl
            externalUrlName
        }
    }
`;

export const MOVE_CONTENT_FOLDER = gql`
    mutation MoveContentFolder($contentFolderId: Int!, $newParentContentFolderId: Int!) {
        moveContentFolder(input: {
            contentFolderId: $contentFolderId,
            newParentContentFolderId: $newParentContentFolderId
        }) {
            id
        }
    }
`;

export const REMOVE_CONTENT_FOLDER_PARENT = gql`
    mutation RemoveContentFolderParent($contentFolderId: Int!) {
        removeContentFolderParent(input: {
            contentFolderId: $contentFolderId
        }) {
            id
        }
    }
`;

export const MOVE_CONTENT_INFO = gql`
    mutation MoveContent($contentInfoId: Int!, $newParentContentFolderId: Int!) {
        moveContentInfo(input: {
            contentInfoId: $contentInfoId,
            newParentContentFolderId: $newParentContentFolderId
        }) {
            id
        }
    }
`;

export const REMOVE_CONTENT_INFO_PARENT = gql`
    mutation RemoveContentParent($contentInfoId: Int!) {
        removeContentInfoParent(input: {
            contentInfoId: $contentInfoId
        }) {
            id
        }
    }
`;

export const CREATE_BOOKING_ON_BEHALF_OF = gql`
    mutation CreateBookingOnBehalfOf($externalChildId: String!, $contentIds: [Int!]!, $lessonTime: DateTime!, $serviceTypeKeycode: String!) {
        createBookingOnBehalfOf(
          input: {externalChildId: $externalChildId, contentIds: $contentIds, lessonTime: $lessonTime, serviceTypeKeycode: $serviceTypeKeycode}
        ) {
          status
          reasonCode
        }
      }
`;

export const BOOKING_LESSON = gql`
    mutation BookLesson($externalChildId: String!, $lessonId: Int!) {
        bookLesson(input: {
            externalChildId: $externalChildId,
            lessonId: $lessonId
        }) {
            id
        }
    }
`;

export const FIND_BOOKABILITY_WITH_FILTER = gql`
    query GetBookability($from: DateTime!, $to: DateTime!, $contentIds: [Int!]!, $serviceTypeKeyCodes: [String!]!) {
        bookability(
            filter: {from: $from, to: $to, contentIds: $contentIds, serviceTypeKeyCodes: $serviceTypeKeyCodes}
        ) {
              bookablePeriods {
                from
                freeSeatsCount
                freePeriodsCount
              }
        }
    }
`;

export const QUERY_ALL_PERFORMERS_AND_FILTER_BY_SERVICE_TYPE = gql`
    query AccreditedUsers($serviceTypeKeycodes: [String]!) {
        accreditedUsers(filter: {serviceTypeKeycodes: $serviceTypeKeycodes}) {
            id
            displayName
            accreditedServiceTypes {
                keycode
                description
            }
          }
    }
`;

export const ALL_PERFORMERS_CONTENT_WITH_SERVICE_TYPE_AND_ACCREDITATION = gql`
    query GetAllPerformersContentAndAccreditation {
        users_filtered(filter: {anyPermissions: [TEACH]}) {
            id
            displayName
        }

        serviceTypes {
            id
            keycode
            description
            primaryColor
        }
        
        contentFolders {
            id
            name
            parentFolderId
            serviceType {
                id
                keycode
            }
        }
        
        contentInfos {
            id
            name
            description
            contentFolderId
            nameExternal
            code
            level
            contentType
            externalUrl
            externalUrlName            
            serviceType {
                id
                keycode
                description
            }
        }

        contentPerformingAccreditations {
            id
            domainUser {
                id
            }
            contentInfo {
                id
            }
        }
    }
`;

export const CREATE_BULK_ACCREDITATION = gql`
    mutation CreateBulkAccreditation($contentInfoIds: [Int]!, $domainUserId: Int!) {
        createContentPerformingAccreditations(input: {
            contentInfoIds: $contentInfoIds,
            domainUserId: $domainUserId
        }) {
            id
        }
    }
`;

export const DELETE_BULK_ACCREDITATION = gql`
    mutation DeleteBulkAccreditation($contentInfoIds: [Int]!, $domainUserId: Int!) {
        deleteContentPerformingAccreditations(input: {
            contentInfoIds: $contentInfoIds,
            domainUserId: $domainUserId
        })
    }
`;

export const HELPDESK_AUTH_TOKEN = gql`
    query GetHelpdeskAuthToken { 
        helpdeskAuthToken 
    }
`;

export const CREATE_CONTENT_FOLDER = gql`
    mutation CreateContentFolder($name: String!, $serviceTypeKeycode: String!, $parentContentFolderId: Int) {
        createContentFolder(input: {
            name: $name,
            serviceTypeKeycode: $serviceTypeKeycode,
            parentContentFolderId: $parentContentFolderId
        }) {
            id
        }
    }
`;

export const UPDATE_CONTENT_FOLDER = gql`
    mutation UpdateContentFolder($contentFolderId: Int!, $name: String!) {
        updateContentFolder(input: {
            contentFolderId: $contentFolderId,
            name: $name
        }) {
            id
        }
    }
`;

export const DELETE_CONTENT_FOLDER = gql`
    mutation DeleteContentFolder($contentFolderId: Int!) {
        deleteContentFolder(input: {
            contentFolderId: $contentFolderId
        })
    }
`;

export const MY_SHIFTS = gql`
        query GetMyShifts($startTime: DateTime, $endTime: DateTime, $includeDeletedShifts: Boolean, $includeOnlyAccreditedServiceTypes: Boolean) {
            me {
            id
            availability(filter: {from: $startTime, to: $endTime, includeDeletedShifts: $includeDeletedShifts, includeOnlyAccreditedServiceTypes: $includeOnlyAccreditedServiceTypes}) {
                id
                performingFrom
                to
                updated
                isDeleted
                bookableServiceTypes {
                    serviceType {
                        keycode
                        description
                    }
                    startTime
                    endTime
                }
            }
        }
    }
`;

export const MY_SHIFT_HISTORY = gql`
    query GetMyShiftHistory($performerId: Int!, $startTime: DateTime!, $endTime: DateTime!, $includeDeletedShifts: Boolean, $includeOnlyAccreditedServiceTypes: Boolean) {
        me {
            id
            availability(filter: {from: $startTime, to: $endTime, includeDeletedShifts: $includeDeletedShifts, includeOnlyAccreditedServiceTypes: $includeOnlyAccreditedServiceTypes}) {
                id
                from
                performingFrom
                to
                bookableServiceTypes {
                    serviceType {
                        keycode
                    }
                }
            }
            amendments(filter: {from: $startTime, to: $endTime}) {
              shift{
                id
              }
              id
              direction
              notes
              durationInMinutes
              startTime
              amendmentType
            }
        }
        performerActivityReport(filter: {from: $startTime, to: $endTime, performerId: $performerId}) {
            summary {
                totalShiftCount
                totalShiftDurationInMinutes
                totalAmendmentCount
                netAmendmentMinutes
            }
        }
    }
`;

export const SHIFT_ADMIN_PERFORMER_ACTIVITY = gql`
    query ShiftAdminPerformerActivity($fromTime: DateTime!, $toTime: DateTime!, $includeDeletedShifts: Boolean, $includeOnlyAccreditedServiceTypes: Boolean) {
        users_filtered(filter: {anyPermissions: [TEACH]}) {
            id
            givenName
            familyName
            displayName
            availability(filter: {from: $fromTime, to: $toTime, includeDeletedShifts: $includeDeletedShifts, includeOnlyAccreditedServiceTypes: $includeOnlyAccreditedServiceTypes}) {
                id
                from
                performingFrom
                to
                bookableServiceTypes {
                    serviceType {
                        keycode
                    }
                }
            }
            amendments(filter: {from: $fromTime, to: $toTime}) {
                id
                direction
                notes
                durationInMinutes
                startTime
                amendmentType
                createdBy
                created
                shift {
                    id
                    from
                    performingFrom
                    to
                    bookableServiceTypes {
                        serviceType {
                            keycode
                        }
                    }
                }
            }
        }
    }
`;

export const CREATE_AMENDMENT = gql`
    mutation CreateAmendment($performerId: Int!, $shiftId: Int, $amendmentType: AmendmentType!, $startTime: DateTime!, $durationInMinutes: Int!, $direction: AmendmentDirection!, $notes: String) {
        createAmendment(input: {performerId: $performerId, shiftId: $shiftId, amendmentType: $amendmentType, startTime: $startTime, durationInMinutes: $durationInMinutes, direction: $direction, notes: $notes}) {
            id
        }
    }
`;

export const DELETE_AMENDMENT = gql`
    mutation DeleteAmendment($id: Int!) {
        deleteAmendment(input: {id: $id}) {
            id
        }
    }
`;

export const FETCH_UPDATES = gql`
    query FetchUpdates($userId: Int!, $timeToCheckShiftsAfter: DateTime!) {
        updates(filter: {userId: $userId, timeToCheckShiftsAfter: $timeToCheckShiftsAfter}) {
            shiftUpdates
        }
    }
`;

export const FETCH_SESSIONS = gql`
    query FetchSessions($from: DateTime, $to: DateTime, $sessionTypes: [SessionType]!, $pageNumber: Int!, $pageSize: Int!, $sessionScope: SessionScope!, $healthFilter: HealthFilter!) {
        fetchSessions(filter: { from: $from, to: $to, sessionTypes: $sessionTypes, pageNumber: $pageNumber, pageSize: $pageSize, sessionScope: $sessionScope, healthFilter: $healthFilter }) {
            sessions {
                id
                from
                to
                seatsCount
                sessionType
                serviceType {
                    keycode
                    primaryColor
                    description
                }
                performer {
                    id
                    displayName
                }
                seats {
                    booking {
                        status
                        child {
                            parent {
                                externalId
                                region
                            }
                        }
                    }
                }
                bookingsCount
                contents {
                    id
                    name
                    level
                    contentType
                    externalUrl
                }
                shift {
                    id
                }
                firstChildJoinTime
            }
            totalSessionsCount
        }
    }
`;

export const FETCH_SESSION_ISSUE_COUNT = gql`
    query FetchSessionIssueCount($from: DateTime!, $to: DateTime!, $sessionTypes: [SessionType]!, $pageNumber: Int!, $pageSize: Int!, $sessionScope: SessionScope!, $healthFilter: HealthFilter!) {
        fetchSessions(filter: { from: $from, to: $to, sessionTypes: $sessionTypes, pageNumber: $pageNumber, pageSize: $pageSize, sessionScope: $sessionScope, healthFilter: $healthFilter }) {
            totalSessionsCount
        }
    }
`;

export const FETCH_CHILD_TAG_METRICS = gql`
    query fetchChildTagMetrics($childId: Int!) {
        fetchChildTagMetrics(filter: {childId: $childId}) {
            count
            tag {
                id
                type
                name
                sentiment
                isInternal
            }
        }
    }
`;

export const FETCH_INTERNAL_TAGS_AND_BOOKING_INFO = gql`
    query FetchInternalTagsAndBookingInfo($bookingId: Int!) {
        tags(filter: {tagScope: INTERNAL}) {
            id
            type
            name
            sentiment
            isInternal
        }
        bookingInfo(filter: {bookingId: $bookingId}) {
            tags {
                id
            }
        }
    }
`;

export const FETCH_INTERNAL_TAGS = gql`
    query FetchInternalTags {
        tags(filter: {tagScope: INTERNAL}) {
            id
            type
            name
            sentiment
            isInternal
        }
    }
`;

export const SUBMIT_MEMBER_TAGS = gql`
    mutation SubmitMemberTags($bookingId: Int!, $tags: [Int]!) {
        submitBookingTags(input: {bookingId: $bookingId, tags: $tags}) {
            id
            status
            child {
                id
                displayName
            }
            tags {
                id
                name
                type
            }
        }
    }
`;

export const CREATE_TAG = gql`
    mutation CreateTag($name: String!, $internalName: String!, $type: TagType!, $sentiment: Sentiment!) {
        createTag(input: {name: $name, internalName: $internalName, type: $type, sentiment: $sentiment}) {
            id
            name
            type
            sentiment
            isInternal
        }
    }
`;

export const UPDATE_TAG = gql`
    mutation UpdateTag($tagId: Int!, $name: String!, $internalName: String!, $type: TagType!, $sentiment: Sentiment!) {
        updateTag(input: {tagId: $tagId, name: $name, internalName: $internalName, type: $type, sentiment: $sentiment}) {
            id
            name
            type
            sentiment
            isInternal
        }
    }
`;

export const DELETE_TAG = gql`
    mutation DeleteTag($tagId: Int!) {
        deleteTag(input: {tagId: $tagId})
    }
`;